export const DASHBOARD_PANEL_SHARE_OPEN_MODAL = "DASHBOARD_PANEL_SHARE_OPEN_MODAL";
export const DASHBOARD_PANEL_SHARE_REQUEST = "DASHBOARD_PANEL_SHARE_REQUEST";
export const DASHBOARD_PANEL_SHARE_RESULT = "DASHBOARD_PANEL_SHARE_RESULT";


export const DASHBOARD_PANEL_GET_DASHBOARD_REQUEST = "DASHBOARD_PANEL_GET_DASHBOARD_REQUEST";
export const DASHBOARD_PANEL_GET_DASHBOARD_RESULT = "DASHBOARD_PANEL_GET_DASHBOARD_RESULT";